<form [formGroup]="parteAForm">
    <div class="card marginCards">
        <div class="card-body" #mySelectViewChild>
            <div class="alternativeinRow gap150" style="align-items: start;">
                <div class="inCol gap30">
                    <div class="form-group">
                        <div class="inCol">
                            <label class="text-bold" style="margin-bottom: 0.5rem;">1. Luogo del
                                decesso *</label>
                            <label>Selezionare</label>
                            <select name="luogoDecesso" id="luogoDecesso" class="custom-select-400"
                                (change)="showInputLuogo($event)" formControlName="fkLuogoDecesso"
                                [ngClass]="{'border-red': invalidBorder('fkLuogoDecesso') == true}"
                                [ngClass]="{'disabledSelect': disableSelect == true}">
                                <option *ngFor="let lDecesso of dizionarioLuogoDecesso" [value]="lDecesso.codice">
                                    {{lDecesso.descrizione}}
                                </option>
                            </select>
                            <input type="text" class="form-control field-height field-22" id="altroLuogoDecesso"
                                style="margin-top: 15px;"
                                *ngIf="selectedOptionLuogo === '9' || parteAForm.get('fkLuogoDecesso')?.value == '9'"
                                formControlName="luogoDecessoAltro"
                                [ngClass]="{'border-danger': invalidBorder('luogoDecessoAltro') == true}">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="inCol" formGroupName="territorioDecesso">
                            <label class="text-bold">Territorio in cui è avvenuto il decesso *</label>
                            <div class="field-36">
                                <label>Comune</label>
                                <input type="text" class="form-control field-height-40" id="comunedecesso"
                                    style="margin-bottom: 10px;" formControlName="fkComuneDecessoDescr"
                                    (change)="onChangeComuneDecesso()"
                                    [ngbTypeahead]="search"
                                    [ngClass]="{'border-danger': invalidBorderComune('fkComuneDecessoDescr', 'territorioDecesso', 'fkComuneDecesso')}">
                            </div>
                            <div class="inRow" style="gap: 0 15px;">
                                <div class="form-group field-14">
                                    <label>Provincia</label>
                                    <input type="text" class="form-control field-height-40" id="provinciadecesso"
                                        formControlName="provincia" readonly
                                        [ngClass]="{'border-danger': invalidBorderGroup('provincia', 'territorioDecesso')}">
                                </div>
                                <div class="form-group field-14">
                                    <div class="inCol">
                                        <label>Codice ASL</label>
                                        <!-- <select name="codiceasl" id="codiceasl" class="custom-select-300"
                                            formControlName="codiceAslDecesso"
                                            [ngClass]="{'border-red': invalidBorderGroup('codiceAslDecesso', 'territorioDecesso')}">
                                            <option *ngFor="let cAsl of aslDescr" [value]="cAsl.codiceAzienda">
                                                {{cAsl.denominazioneAzienda}}
                                            </option>
                                        </select> -->
                                        <input type="text" class="form-control field-height-40" id="codiceasl"
                                        formControlName="descrAslDecesso" readonly
                                        [ngClass]="{'border-danger': invalidBorderGroup('codiceAslDecesso', 'territorioDecesso')}">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group field-50 marginCards">
                        <div class="inCol">
                            <label class="text-bold">3. Stato di gravidanza della deceduta negli ultimi
                                12
                                mesi di vita</label>
                            <label>(da compilare per le donne decedute in età
                                fertile)</label>
                            <label>Selezionare</label>
                            <select name="statogravidanza" id="statogravidanza" class="custom-select-400"
                                formControlName="fkStatoGravidanza" [ngClass]="{'disabledSelect': disableSelect == true}">
                                <option *ngFor="let sGravidanza of dizionarioStatoGravidanza"
                                    [value]="sGravidanza.codice">{{sGravidanza.descrizione}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="inCol gap30">
                    <div class="form-group">
                        <div class="inCol">
                            <label class="text-bold">2. Riscontro diagnostico *</label>
                            <label>E' stato richiesto?</label>
                            <div class="inRow" style="gap: 0 10px;">
                                <div class="inRowDispositionRadio form-check-inline">
                                    <label style="margin-bottom: 0px;">SI</label>
                                    <input type="radio" class="form-check-input" value="S"
                                        formControlName="riscontroDiagnostico" id="riscontroDiagnostico"
                                        [ngClass]="{'border-red-radio': invalidBorder('riscontroDiagnostico')}">
                                </div>
                                <div class="inRowDispositionRadio form-check-inline">
                                    <label style="margin-bottom: 0px;">NO</label>
                                    <input type="radio" class="form-check-input" value="N"
                                        formControlName="riscontroDiagnostico" id="riscontroDiagnostico"
                                        [ngClass]="{'border-red-radio': invalidBorder('riscontroDiagnostico')}">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="inCol" formGroupName="causaIniziale">
                            <label class="headerCustomTable">Causa
                                iniziale</label>
                            <div class="inCol" style="gap: 0px;">
                                <div class="inRow" style="gap: 0px;">
                                    <label class="contentCustomTable"
                                        style="margin-bottom: 0;text-align: center;">I-XIX</label>
                                    <input type="text" id="i_xix_1" formControlName="i_xix_1"
                                        class="contentCustomTable">
                                    <input type="text" id="i_xix_2" formControlName="i_xix_2"
                                        class="contentCustomTable">
                                    <input type="text" id="i_xix_3" formControlName="i_xix_3"
                                        class="contentCustomTable">
                                    <input type="text" id="i_xix_4" formControlName="i_xix_4"
                                        class="contentCustomTable">
                                </div>
                                <div class="inRow" style="gap: 0px;">
                                    <label class="contentCustomTable"
                                        style="margin-bottom: 0;text-align: center;">XX</label>
                                    <input type="text" id="xx_1" formControlName="xx_1" class="contentCustomTable">
                                    <input type="text" id="xx_2" formControlName="xx_2" class="contentCustomTable">
                                    <input type="text" id="xx_3" formControlName="xx_3" class="contentCustomTable">
                                    <input type="text" id="xx_4" formControlName="xx_4" class="contentCustomTable">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card marginCards">
        <div class="card-body">
            <div class="inCol gap30">
                <div class="inCol" style="align-items: start;gap: 30px 0;">
                    <div class="group-inline">
                        <div class="form-group">
                            <div class="inCol" style="gap: 25px 0;">
                                <label class="text-bold">4. PARTE I *</label>
                                <label class="text-bold">CAUSA DI MORTE: sequenza di
                                    condizioni morbose o traumatismi/avvelenamenti che ha condotto a
                                    morte</label>
                                <div class="group-inline" style="gap: 0 5px; align-items: center;">
                                    <div class="inCol" style="gap: 15px 0;">
                                        <div class="inRow" style="gap: 0 25px;align-items: center;"
                                            formGroupName="causaMortePatologia">
                                            <ng-template #tipContent>Scegliere la SOLA patologia o trauma
                                                che ha
                                                dato inizio alla sequenza</ng-template>
                                            <label class="text-bold" style="cursor: pointer;" [ngbTooltip]="tipContent">
                                                Patologia
                                            </label>
                                            <div class="inRow field-60" style="gap: 0 3px;">
                                                <label style="margin-bottom: 0;">1</label>
                                                <input type="text" class="form-control field-height-40" id="patologia"
                                                    formControlName="causaDiMorte1" tabindex="1"
                                                    [ngbTypeahead]="searchIcd10"
                                                    [ngClass]="{'border-danger': invalidBorderIcd10('causaMortePatologia', 'causaDiMorte1', 'causaDiMorte1Cod')}">
                                            </div>
                                        </div>
                                        <div class="inRow" style="gap: 0 10px;" formGroupName="causaMorteCondizioni">
                                            <div class="inRow" style="gap: 0 10px; align-items: center;">
                                                <ng-template #tipContent2>Eventuali condizioni o
                                                    complicazione
                                                    che fanno parte della sequenza</ng-template>
                                                <label class="text-bold" style="cursor: pointer;"
                                                    [ngbTooltip]="tipContent2">
                                                    Condizioni
                                                </label>
                                                <div style="width: 1px;height: 125px;background-color: black;">
                                                </div>
                                            </div>
                                            <div class="inCol field-60" style="gap: 15px 0;">
                                                <div class="inRow" style="gap: 0 3px;" formGroupName="condizione1">
                                                    <label>2</label>
                                                    <input type="text" class="form-control field-height-40"
                                                        id="condizione1" formControlName="causaDiMorte2" tabindex="5"
                                                        [ngbTypeahead]="searchIcd10">
                                                </div>
                                                <div class="inRow" style="gap: 0 3px;" formGroupName="condizione2">
                                                    <label>3</label>
                                                    <input type="text" class="form-control field-height-40"
                                                        id="condizione2" formControlName="causaDiMorte3" tabindex="9"
                                                        [ngbTypeahead]="searchIcd10" [readonly]="!activateCondizione2">
                                                </div>
                                                <div class="inRow" style="gap: 0 3px;" formGroupName="condizione3">
                                                    <label>4</label>
                                                    <input type="text" class="form-control field-height-40"
                                                        id="condizione3" formControlName="causaDiMorte4" tabindex="13"
                                                        [ngbTypeahead]="searchIcd10" [readonly]="!activateCondizione3">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="inCol marginTop" style="gap: 5px 0;">
                                        <div class="group-inline" style="gap: 0 5px;position: relative;">
                                            <div class="inCol field-4" style="position: relative;">
                                                <label class="absoluteText">Anni
                                                    o</label>
                                                <div formGroupName="causaMortePatologia">
                                                    <input type="number" (input)="limitInput($event.target, 2)"
                                                        class="form-control field-height-40" id="anni1" tabindex="2"
                                                        formControlName="causaDiMorte1Anni">
                                                </div>
                                                <div formGroupName="causaMorteCondizioni">
                                                    <div formGroupName="condizione1" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            class="form-control field-height-40" id="anni2" tabindex="6"
                                                            formControlName="causaDiMorte2Anni">
                                                    </div>
                                                    <div formGroupName="condizione2" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            tabindex="10" class="form-control field-height-40"
                                                            id="causaDiMorte3Anni" formControlName="causaDiMorte3Anni"
                                                            [readonly]="!activateCondizione2">
                                                    </div>
                                                    <div formGroupName="condizione3" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            tabindex="14" class="form-control field-height-40"
                                                            id="anni4" formControlName="causaDiMorte4Anni"
                                                            [readonly]="!activateCondizione3">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="inCol field-4" style="position: relative;">
                                                <label class="absoluteText">Mesi
                                                    o</label>
                                                <div formGroupName="causaMortePatologia">
                                                    <input type="number" (input)="limitInput($event.target, 2)"
                                                        class="form-control field-height-40" id="mesi1"
                                                        formControlName="causaDiMorte1Mesi" tabindex="3">
                                                </div>
                                                <div formGroupName="causaMorteCondizioni">
                                                    <div formGroupName="condizione1" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            class="form-control field-height-40" id="mesi2" tabindex="7"
                                                            formControlName="causaDiMorte2Mesi">
                                                    </div>
                                                    <div formGroupName="condizione2" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            class="form-control field-height-40" id="causaDiMorte3Mesi"
                                                            tabindex="11" formControlName="causaDiMorte3Mesi"
                                                            [readonly]="!activateCondizione2">
                                                    </div>
                                                    <div formGroupName="condizione3" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            tabindex="15" class="form-control field-height-40"
                                                            id="mesi4" formControlName="causaDiMorte4Mesi"
                                                            [readonly]="!activateCondizione3">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="inCol field-4" style="position: relative;">
                                                <label class="absoluteText">Giorni</label>
                                                <ng-template #tipContentGiorni>Tempo intercorso tra
                                                    l’insorgenza della causa
                                                    indicata e la morte</ng-template>
                                                <label class="text-bold absoluteText"
                                                    style="cursor: pointer;right: -10px;"
                                                    [ngbTooltip]="tipContentGiorni">
                                                    <svg class="s-icon icon-xs">
                                                        <use style="fill: black;"
                                                            xlink:href="/assets/icons/sprite.svg#info">
                                                        </use>
                                                    </svg>
                                                </label>
                                                <div formGroupName="causaMortePatologia">
                                                    <input type="number" (input)="limitInput($event.target, 2)"
                                                        class="form-control field-height-40" id="giorni1"
                                                        formControlName="causaDiMorte1Giorni" tabindex="4">
                                                </div>
                                                <div formGroupName="causaMorteCondizioni">
                                                    <div formGroupName="condizione1" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            tabindex="8" class="form-control field-height-40"
                                                            id="giorni2" formControlName="causaDiMorte2Giorni">
                                                    </div>
                                                    <div formGroupName="condizione2" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            class="form-control field-height-40" id="giorni3"
                                                            tabindex="12" formControlName="causaDiMorte3Giorni"
                                                            [readonly]="!activateCondizione2">
                                                    </div>
                                                    <div formGroupName="condizione3" style="margin-top: 15px;">
                                                        <input type="number" (input)="limitInput($event.target, 2)"
                                                            tabindex="16" class="form-control field-height-40"
                                                            id="giorni4" formControlName="causaDiMorte4Giorni"
                                                            [readonly]="!activateCondizione3">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="inCol" style="gap: 25px 0;">
                        <label class="text-bold">4. PARTE II<span>
                                Altri stati morbosi rilevanti: indicare altre condizioni morbose o
                                traumatismi/avvelenamenti che non fanno parte della sequenza
                                riportata nel quesito 4 Parte I, ma che hanno contribuito al decesso</span>
                        </label>
                        <div class="group-inline" style="gap: 0 5px;" formGroupName="altriStatiMorbosi">
                            <div class="inCol field-70" style="gap: 10px 0;">
                                <div formGroupName="stato1">
                                    <input type="text" class="form-control field-height-40" id="stato1"
                                        formControlName="statiMorbosi1" [ngbTypeahead]="searchIcd10" tabindex="20">
                                </div>
                                <div formGroupName="stato2">
                                    <input type="text" class="form-control field-height-40" id="stato2"
                                        [ngbTypeahead]="searchIcd10" tabindex="24" formControlName="statiMorbosi2"
                                        [readonly]="!activateStato2">
                                </div>
                                <div formGroupName="stato3">
                                    <input type="text" class="form-control field-height-40" id="stato3"
                                        [ngbTypeahead]="searchIcd10" tabindex="28" formControlName="statiMorbosi3"
                                        [readonly]="!activateStato3">
                                </div>
                            </div>
                            <div class="group-inline marginTop" style="gap: 0 5px;">
                                <div class="inCol field-4" style="gap: 10px 0;position: relative;">
                                    <label class="absoluteText">Anni o</label>
                                    <div formGroupName="stato1">
                                        <input type="number" (input)="limitInput($event.target, 2)"
                                            class="form-control field-height-40" formControlName="statiMorbosi1Anni"
                                            id="annistati1" tabindex="21">
                                    </div>
                                    <div formGroupName="stato2">
                                        <input type="number" (input)="limitInput($event.target, 2)" tabindex="25"
                                            class="form-control field-height-40" formControlName="statiMorbosi2Anni"
                                            id="annistati2" [readonly]="!activateStato2">
                                    </div>
                                    <div formGroupName="stato3">
                                        <input type="number" (input)="limitInput($event.target, 2)" tabindex="29"
                                            class="form-control field-height-40" formControlName="statiMorbosi3Anni"
                                            id="annistati3" [readonly]="!activateStato3">
                                    </div>
                                </div>
                                <div class="inCol field-4" style="gap: 10px 0;position: relative;">
                                    <label class="absoluteText">Mesi o</label>
                                    <div formGroupName="stato1">
                                        <input type="number" (input)="limitInput($event.target, 2)"
                                            class="form-control field-height-40" formControlName="statiMorbosi1Mesi"
                                            id="mesistati1" tabindex="22">
                                    </div>
                                    <div formGroupName="stato2">
                                        <input type="number" (input)="limitInput($event.target, 2)" tabindex="26"
                                            class="form-control field-height-40" formControlName="statiMorbosi2Mesi"
                                            id="mesistati2" [readonly]="!activateStato2">
                                    </div>
                                    <div formGroupName="stato3">
                                        <input type="number" (input)="limitInput($event.target, 2)" tabindex="30"
                                            class="form-control field-height-40" formControlName="statiMorbosi3Mesi"
                                            id="mesistati3" [readonly]="!activateStato3">
                                    </div>
                                </div>
                                <div class="inCol field-4" style="gap: 10px 0;position: relative;">
                                    <label class="absoluteText">Giorni</label>
                                    <div formGroupName="stato1">
                                        <input type="number" (input)="limitInput($event.target, 2)"
                                            class="form-control field-height-40" formControlName="statiMorbosi1Giorni"
                                            id="giornistati1" tabindex="23">
                                    </div>
                                    <div formGroupName="stato2">
                                        <input type="number" (input)="limitInput($event.target, 2)" tabindex="27"
                                            class="form-control field-height-40" formControlName="statiMorbosi2Giorni"
                                            id="giornistati2" [readonly]="!activateStato2">
                                    </div>
                                    <div formGroupName="stato3">
                                        <input type="number" (input)="limitInput($event.target, 2)" tabindex="31"
                                            class="form-control field-height-40" formControlName="statiMorbosi3Giorni"
                                            id="giornistati3" [readonly]="!activateStato3">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              <div class="inRow" style="gap: 0 10px;">
                <label class="text-bold">Selezionare se trattasi di un Traumatismo/Avvelenamento</label>
                <input type="checkbox" class="checkboxMortem" value="true" [checked]="!isHiddenQuesiti" id="checkboxQuesiti" [disabled]="!parteAForm.enabled"
                       (click)="hideQuesitiSubject()">
              </div>
            </div>
        </div>
    </div>
    <div class="card marginCards" *ngIf="!isHiddenQuesiti">
        <div class="card-body" >
            <div class="inCol" style="align-items: start;gap: 30px 0;">
                <label class="text-bold">(Quesiti da 5 a 9 Compilare se nel quesito
                    4 Parte I è stato riportato un Traumatismo/Avvelenamento)</label>
                <div class="form-group field-80">
                    <div class="inCol">
                        <label class="text-bold">5. Evento che ha dato origine al
                            traumatismo/avvelenamento indicato nel quesito 4 Parte I <span
                                *ngIf="!isHiddenQuesiti">*</span></label>
                        <label>(es. caduta da scala a pioli, impiccamento...)
                            (Specifica inoltre se causato da eventi catastrofici)</label>
                        <input type="text" class="form-control field-height-40" id="eventoorigine"
                            formControlName="eventoOrigineTraumatismo"
                            [ngClass]="{'border-danger': invalidBorder('eventoOrigineTraumatismo')}">
                    </div>
                </div>
                <div class="form-group field-50">
                    <div class="inCol">
                        <label class="text-bold">6. Modalità di
                            avvelenamento/traumatismo <span>(indicare la più verosimile, da
                                specificare sempre) <span *ngIf="!isHiddenQuesiti">*</span></span></label>
                        <label>Selezionare</label>
                        <select name="modalitaAvvelenamento" id="modalitaAvvelenamento" class="custom-select-350"
                            formControlName="fkModalitaTraumatismo" (change)="setSelectedOptionAccidentale($event)"
                            [ngClass]="{'border-red': invalidBorder('fkModalitaTraumatismo')}"
                            [ngClass]="{'disabledSelect': disableSelect == true}">
                            <option *ngFor="let mTraumatismo of dizionarioModalitaTraumatismo"
                                [value]="mTraumatismo.codice">
                                {{mTraumatismo.descrizione}}
                            </option>
                        </select>
                        <div class="inRow" style="gap: 0 15px; margin-top: 15px; align-items: center;"
                            *ngIf="!isHiddenAccidentale || parteAForm.get('fkModalitaTraumatismo')?.value == '1'">
                            <label style="font-size: 14px;">Se accidentale specificare se infortunio sul
                                lavoro</label>
                            <div class="inRow" style="gap: 0 10px;">
                                <label>SI</label>
                                <input type="radio" value="S" formControlName="traumatismoSulLavoro"
                                    id="modalitaAccidentale" class="checkboxMortem">
                                <label>NO</label>
                                <input type="radio" value="N" formControlName="traumatismoSulLavoro"
                                    id="modalitaAccidentale" class="checkboxMortem">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inCol">
                    <label class="text-bold">7. In caso di incidente da trasporto specificare
                        anche</label>
                    <div class="inCol" style="gap: 15px 0;margin-left: 15px;" formGroupName="incidenteTrasporti">
                        <div class="inCol field-36" style="gap: 5px 0">
                            <label>7.1 Mezzo di trasporto della vittima al momento
                                dell'incidente</label>
                            <input type="text" class="form-control field-height-40" id="mezzoTrasporto"
                                formControlName="incidenteTrasportoMezzo"
                                [ngClass]="{'border-danger': invalidBorderGroup('incidenteTrasportoMezzo', 'incidenteTrasporti')}">
                        </div>
                        <div class="inCol" style="gap: 5px 0">
                            <label>7.2 Ruolo della vittima</label>
                            <label>Selezionare</label>
                            <select name="ruoloVittima" id="ruoloVittima" class="custom-select-400 field-height-40"
                                formControlName="fkIncidenteTrasportoRuolo"
                                [ngClass]="{'border-red': invalidBorderGroup('fkIncidenteTrasportoRuolo', 'incidenteTrasporti')}"
                                [ngClass]="{'disabledSelect': disableSelect == true}">
                                <option *ngFor="let tRuolo of dizionarioTrasportoRuolo" [value]="tRuolo.codice">
                                    {{tRuolo.descrizione}}
                                </option>
                            </select>
                        </div>
                        <div class="inCol field-36" style="gap: 5px 0">
                            <label>7.3 Tipo di incidente</label>
                            <input type="text" class="form-control field-height-40" id="tipoIncidente"
                                (change)="setSelectedOptionTipoIncidente" formControlName="incidenteTrasportoTipo"
                                [ngClass]="{'border-danger': invalidBorderGroup('incidenteTrasportoTipo', 'incidenteTrasporti')}">
                        </div>
                        <div class="inCol field-36" style="gap: 5px 0">
                            <label>7.4 In caso di scontro indicare
                                l'oggetto</label>
                            <input type="text" class="form-control field-height-40" id="oggettoScontro"
                                formControlName="incidenteTrasportoScontro">
                        </div>
                    </div>
                </div>
                <div class="inCol" style="gap: 15px 0;">
                    <label class="text-bold">8. Data dell'evento che ha dato origine
                        al traumatismo/avvelenamento</label>
                    <div class="group-inline" formGroupName="dataEvento">
                        <div class="form-group field-14" style="margin-right: 20px;">
                            <label class="textCenter">Data</label>
                            <div class="input-group">
                                <input type="text" class="form-control field-height-40" placeholder="yyyy-mm-dd"
                                    name="data8selected" ngbDatepicker #d="ngbDatepicker"
                                    [minDate]="{year: 1900, month: 1, day: 1}"
                                    [maxDate]="{year: dataAttuale.getFullYear(), month: dataAttuale.getMonth() + 1, day: dataAttuale.getDate()}"
                                    formControlName="data8selected"
                                    (dateSelect)="onDateSelect($event, 'dataEvento', 'data8selected')"
                                    [ngClass]="{'border-danger': invalidBorderGroup('data8selected', 'dataEvento')}" />
                                <button class="btn btn-secondary field-height-40" style="align-items: center;"
                                    (click)="d.toggle()" type="button">
                                    <img src="../assets/icons/calendar_ko.png" class="img-responsive"
                                        style="width: 20px; height:20px">
                                </button>
                            </div>
                        </div>
                        <div class="form-group field-2" style="padding-right: 10px;">
                            <label class="textCenter">Ora</label>
                            <input type="number" (keydown)="onHourInput($event, 2)"
                                class="form-control field-height-40" id="oraEvento" formControlName="orarioEventoHh"
                                [ngClass]="{'border-danger': invalidBorderGroup('orarioEventoHh', 'dataEvento')}"
                                >
                        </div>
                        <div class="form-group field-2">
                            <label class="textCenter">Minuti</label>
                            <input type="number" (keydown)="onMinuteInput($event, 2)" min="0" max="59"
                                class="form-control field-height-40" id="minutiEvento" formControlName="orarioEventoMm"
                                [ngClass]="{'border-danger': invalidBorderGroup('orarioEventoMm', 'dataEvento')}">
                        </div>
                    </div>
                </div>
                <div class="inCol" style="gap: 15px 0;">
                    <label class="text-bold">9. Luogo dell'evento che ha dato
                        origine al Traumatismo/avvelenamento</label>
                    <div class="inCol field-24">
                        <label>Selezionare</label>
                        <select name="luogoTraumatismo" id="luogoTraumatismo" class="custom-select-400"
                            (change)="showInputLuogoTraumatismo($event)" formControlName="fkLuogoEvento"
                            [ngClass]="{'border-red': invalidBorder('fkLuogoEvento')}"
                            [ngClass]="{'disabledSelect': disableSelect == true}">
                            <option *ngFor="let lEvento of dizionarioLuogoEvento" [value]="lEvento.codice">
                                {{lEvento.descrizione}}
                            </option>
                        </select>
                        <input type="text" class="form-control field-height" id="altroLuogoEvento"
                            style="margin-top: 15px;" *ngIf="selectedOptionLuogoTraumatismo === '9'"
                            formControlName="altroLuogoEvento"
                            [ngClass]="{'border-danger': invalidBorder('altroLuogoEvento')}">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-body">
            <div class="inCol" style="gap: 15px 0;">
                <label class="text-bold">Dichiaro che le cause della morte
                    secondo scienza e coscienza, sono quelle da me specificate</label>
                <div class="group-inline" formGroupName="dichiarazioni">
                    <div class="form-group field-14" style="margin-right: 20px;">
                        <label class="textCenter">Data *</label>
                        <div class="input-group">
                            <input type="text" class="form-control field-height-40" placeholder="yyyy-mm-dd"
                                name="dataCompilazione" ngbDatepicker #d="ngbDatepicker"
                                [minDate]="{year: 1900, month: 1, day: 1}"
                                [maxDate]="{year: dataAttuale.getFullYear(), month: dataAttuale.getMonth() + 1, day: dataAttuale.getDate()}"
                                (dateSelect)="onDateSelect($event, 'dichiarazioni', 'dataCompilazione')"
                                formControlName="dataCompilazione"
                                [ngClass]="{'border-danger': invalidBorderGroup('dataCompilazione', 'dichiarazioni')}" />
                            <button class="btn btn-secondary field-height-40" style="align-items: center;"
                                (click)="d.toggle()" type="button">
                                <img src="../assets/icons/calendar_ko.png" class="img-responsive"
                                    style="width: 20px; height:20px">
                            </button>
                        </div>
                    </div>
                    <div class="form-group field-28">
                        <label>Nome e cognome *</label>
                        <input type="text" class="form-control field-height-40" id="nomeCognomeDichiarazioni"
                            formControlName="nomeCognomeMedico"
                            [ngClass]="{'border-danger': invalidBorderGroup('nomeCognomeMedico', 'dichiarazioni')}">
                    </div>
                    <div class="form-group field-18">
                        <label>Telefono *</label>
                        <input type="tel" (input)="limitInput($event.target, 20)" class="form-control field-height-40"
                            id="telefonoDichiarazioni" formControlName="telefonoRiferimento"
                            [ngClass]="{'border-danger': invalidBorderGroup('telefonoRiferimento', 'dichiarazioni')}">
                    </div>
                    <div class="form-group field-18">
                        <div class="inCol">
                            <label>Tipo medico *</label>
                            <select name="fkTipoMedico" id="fkTipoMedico" class="custom-select-250"
                                formControlName="fkTipoMedico"
                                [ngClass]="{'border-red': invalidBorderGroup('fkTipoMedico', 'dichiarazioni')}"
                                [ngClass]="{'disabledSelect': disableSelect == true}">
                                <option *ngFor="let tMedico of dizionarioTipoMedico" [value]="tMedico.codice">
                                    {{tMedico.descrizione}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
